// istanbul ignore file
import { ModuleWithProviders, NgModule } from '@angular/core';
import { StorageConfig } from '@ionic/storage-angular';
import { SecureStoragePlugin } from './secure-storage-plugin';
import { LegacyStorageConfigToken, SecureStorageConfig, SecureStorageConfigToken, StorageLegacyService } from './storage.service';

@NgModule({
  providers: [StorageLegacyService, SecureStoragePlugin],
})
export class StorageLegacyModule {
  static forRoot(
    { name = 'secure_storage', securePrompt = true }: SecureStorageConfig = {},
    storageConfig?: StorageConfig
  ): ModuleWithProviders<StorageLegacyModule> {
    return {
      ngModule: StorageLegacyModule,
      providers: [
        {
          provide: LegacyStorageConfigToken,
          useValue: storageConfig,
        },
        {
          provide: SecureStorageConfigToken,
          useValue: { name, securePrompt },
        },
      ],
    };
  }
}
